<template>
  <v-container
    class="align-content-start"
    fill-height
    fluid
  >
    <v-row>
      <section-header
        :breadcrumb-items="breadcrumb"
        :button-title="$t('Assumptions.EditAssumptions.Title')"
        :button-icon="''"
        button
        button-to="EditAssumptions"
      />
    </v-row>
  </v-container>
</template>

  <script>
import i18nRouteMeta                     from '@/mixins/i18n/i18nRouteMeta'
import SectionHeader                     from '@/theme/default/components/common/SectionHeader'

export default {
  name      : 'InterestRate',
  components: {
    SectionHeader
  },
  mixins   : [i18nRouteMeta],
  dataStore: {
    appToolbarExtended: 'App.Config.AppToolbarExtended'
  },
  data () {
    return {
      breakpoint    : (this.appToolbarExtended && this.$vuetify.breakpoint.smAndDown ? 12 : 6),
      minBlockHeight: 364,
      editMode      : false
    }
  },
  computed: {
    breadcrumb () {
      return [{
        text    : this.$t('InterestRate.HeaderTitle'),
        disabled: true
      }]
    }
  },
  watch: {
    appToolbarExtended (val) {
      this.breakpoint = val && this.$vuetify.breakpoint.smAndDown ? 12 : 6
    },

    '$vuetify.breakpoint.smAndDown': {
      handler (val) {
        this.breakpoint = val && this.appToolbarExtended ? 12 : 6
      }
    }
  },
  created () {},
  beforeDestroy () {},
  methods: {}
}
  </script>

  <style scoped>
  </style>
